<template>
	<div>
		<div class="p-6 bg-white shadow-sm rounded-2xl my-10">
			<div>
				<div class="flex items-center justify-between mb-8">
					<div class="font-semibold text-neutral-600">
						Thống kê học can thiệp
					</div>
					<div class="flex items-center"></div>
				</div>
			</div>
			<div
				class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 3xl:grid-cols-5 w-full"
			>
				<div
					class="p-6 border border-neutral-200 w-full border-b-0 rounded-t-lg md:rounded-tr-none lg:border-b 3xl:rounded-l-lg"
				>
					<div
						class="text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center"
					>
						<img
							src="@/assets/images/icons/clock.png"
							alt=""
							width="32"
							height="32"
							class="mr-2 mb-2"
							style="height: 32px; min-width: 32px"
						/>
						{{ stats.total_non_cancelled_hours }}h/{{
							stats.total_hours
						}}h
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Giờ đã học/giờ dự kiến
						</span>
					</div>
				</div>
				<div
					class="p-6 border border-neutral-200 w-full md:rounded-tr-lg md:border-b-0 md:border-l-0 lg:rounded-tr-none lg:border-b"
				>
					<div
						class="text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center"
					>
						<img
							src="@/assets/images/icons/clock.png"
							alt=""
							width="32"
							height="32"
							class="mr-2 mb-2"
							style="height: 32px; min-width: 32px"
						/>
						{{ stats.total_unscheduled_hours }}h
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Giờ học phát sinh</span
						>
					</div>
				</div>
				<div
					class="p-6 border border-neutral-200 w-full border-t-0 md:border-t lg:border-l-0 lg:rounded-r-lg 3xl:rounded-none"
				>
					<div
						class="text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center"
					>
						<img
							src="@/assets/images/icons/clock.png"
							alt=""
							width="32"
							height="32"
							class="mr-2 mb-2"
							style="height: 32px; min-width: 32px"
						/>
						{{ stats.incompleted_hours }}h
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Giờ chưa học</span
						>
					</div>
				</div>
				<div
					class="p-6 border border-neutral-200 w-full border-t-0 md:border-t md:border-l-0 md:rounded-br-lg lg:border-l lg:rounded-bl-lg lg:rounded-r-none lg:border-t-0 3xl:rounded-none 3xl:border-l-0 3xl:border-r-0 3xl:border-t"
				>
					<div
						class="text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center"
					>
						<img
							src="@/assets/images/icons/clock.png"
							alt=""
							width="32"
							height="32"
							class="mr-2 mb-2"
							style="height: 32px; min-width: 32px"
						/>
						{{ stats.total_cancelled_hours }}h
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Giờ xin nghỉ</span
						>
					</div>
				</div>
				<div
					class="p-6 border border-neutral-200 w-full border-t-0 rounded-b-lg lg:rounded-l-none lg:border-l-0 3xl:border-l 3xl:border-t 3xl:rounded-r-lg"
				>
					<div
						class="text-33 font-bold text-neutral-600 mb-6 flex flex-nowrap items-center"
					>
						<img
							src="@/assets/images/icons/user.png"
							alt=""
							width="32"
							height="32"
							class="mr-2"
							style="height: 32px; min-width: 32px"
						/>
						{{ stats.staffs_count }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Giáo viên dạy</span
						>
					</div>
				</div>
			</div>
		</div>
		<div
			class="grid gap-8 mb-10 md-down:gap-4 grid-cols-2 md-down:grid-cols-1"
		>
			<div
				class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
			>
				<div class="flex items-center flex-nowrap">
					<svg
						width="21"
						height="20"
						viewBox="0 0 21 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clip-path="url(#clip0_1704:5240)">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M1.66797 1.66667C1.66797 0.746192 2.40767 0 3.32014 0H16.5375C17.45 0 18.1897 0.746192 18.1897 1.66667V8.81793C17.4244 8.50542 16.5878 8.33333 15.7114 8.33333C12.0616 8.33333 9.10275 11.25 9.10275 14.9319C9.10275 16.9231 9.96809 18.7784 11.3401 20H3.32014C2.40767 20 1.66797 19.2538 1.66797 18.3333V1.66667ZM2.9071 7.5C2.9071 7.26988 3.09203 7.08333 3.32014 7.08333H11.168C11.3961 7.08333 11.581 7.26988 11.581 7.5C11.581 7.73012 11.3961 7.91667 11.168 7.91667H3.32014C3.09203 7.91667 2.9071 7.73012 2.9071 7.5ZM2.9071 10C2.9071 9.76988 3.09203 9.58333 3.32014 9.58333H9.51579C9.74391 9.58333 9.92884 9.76988 9.92884 10C9.92884 10.2301 9.74391 10.4167 9.51579 10.4167H3.32014C3.09203 10.4167 2.9071 10.2301 2.9071 10ZM2.9071 12.5C2.9071 12.2699 3.09203 12.0833 3.32014 12.0833H7.86362C8.09174 12.0833 8.27666 12.2699 8.27666 12.5C8.27666 12.7301 8.09174 12.9167 7.86362 12.9167H3.32014C3.09203 12.9167 2.9071 12.7301 2.9071 12.5ZM2.9071 15C2.9071 14.7699 3.09203 14.5833 3.32014 14.5833H6.21145C6.43956 14.5833 6.62449 14.7699 6.62449 15C6.62449 15.2301 6.43956 15.4167 6.21145 15.4167H3.32014C3.09203 15.4167 2.9071 15.2301 2.9071 15ZM2.9071 3.75C2.9071 3.28976 3.27695 2.91667 3.73319 2.91667H14.8854C15.3416 2.91667 15.7114 3.28976 15.7114 3.75C15.7114 4.21024 15.3416 4.58333 14.8854 4.58333H3.73319C3.27695 4.58333 2.9071 4.21024 2.9071 3.75Z"
								fill="#2AA797"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M15.7114 20C18.4489 20 20.668 17.7614 20.668 15C20.668 12.2386 18.4489 10 15.7114 10C12.974 10 10.7549 12.2386 10.7549 15C10.7549 17.7614 12.974 20 15.7114 20ZM17.5514 13.106C17.7328 12.923 18.027 12.923 18.2085 13.106C18.3877 13.2869 18.3899 13.5786 18.2151 13.7622L15.7417 16.8811C15.7381 16.8856 15.7343 16.8899 15.7302 16.894C15.5488 17.077 15.2546 17.077 15.0731 16.894L13.4334 15.2399C13.252 15.0569 13.252 14.7601 13.4334 14.577C13.6149 14.394 13.9091 14.394 14.0906 14.577L15.3877 15.8855L17.539 13.1201C17.5429 13.1151 17.547 13.1105 17.5514 13.106Z"
								fill="#2AA797"
							/>
						</g>
						<defs>
							<clipPath id="clip0_1704:5240">
								<rect
									width="20"
									height="20"
									fill="white"
									transform="translate(0.667969)"
								/>
							</clipPath>
						</defs>
					</svg>
					<div class="text-neutral-500 text-sm ml-2">
						Báo cáo hoàn thành
					</div>
				</div>
				<div class="flex items-center flex-nowrap justify-between">
					<div class="text-neutral-600 font-bold text-4xl">
						{{ stats.completed_lesson_report_count }}
					</div>
				</div>
			</div>
			<div
				class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
			>
				<div class="flex items-center flex-nowrap">
					<svg
						width="21"
						height="20"
						viewBox="0 0 21 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clip-path="url(#clip0_1704:5253)">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M2.83073 0C1.91025 0 1.16406 0.746192 1.16406 1.66667V18.3333C1.16406 19.2538 1.91026 20 2.83073 20H10.921C9.53699 18.7784 8.66406 16.9231 8.66406 14.9319C8.66406 11.25 11.6488 8.33333 15.3307 8.33333C16.2148 8.33333 17.0587 8.50542 17.8307 8.81793V1.66667C17.8307 0.746192 17.0845 0 16.1641 0H2.83073ZM2.83073 7.08333C2.60061 7.08333 2.41406 7.26988 2.41406 7.5C2.41406 7.73012 2.60061 7.91667 2.83073 7.91667H10.7474C10.9775 7.91667 11.1641 7.73012 11.1641 7.5C11.1641 7.26988 10.9775 7.08333 10.7474 7.08333H2.83073ZM2.83073 9.58333C2.60061 9.58333 2.41406 9.76988 2.41406 10C2.41406 10.2301 2.60061 10.4167 2.83073 10.4167H9.08073C9.31085 10.4167 9.4974 10.2301 9.4974 10C9.4974 9.76988 9.31085 9.58333 9.08073 9.58333H2.83073ZM2.83073 12.0833C2.60061 12.0833 2.41406 12.2699 2.41406 12.5C2.41406 12.7301 2.60061 12.9167 2.83073 12.9167H7.41406C7.64418 12.9167 7.83073 12.7301 7.83073 12.5C7.83073 12.2699 7.64418 12.0833 7.41406 12.0833H2.83073ZM2.83073 14.5833C2.60061 14.5833 2.41406 14.7699 2.41406 15C2.41406 15.2301 2.60061 15.4167 2.83073 15.4167H5.7474C5.97751 15.4167 6.16406 15.2301 6.16406 15C6.16406 14.7699 5.97751 14.5833 5.7474 14.5833H2.83073ZM3.2474 2.91667C2.78716 2.91667 2.41406 3.28976 2.41406 3.75C2.41406 4.21024 2.78716 4.58333 3.2474 4.58333H14.4974C14.9576 4.58333 15.3307 4.21024 15.3307 3.75C15.3307 3.28976 14.9576 2.91667 14.4974 2.91667H3.2474Z"
								fill="#94A3B8"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M20.3307 15C20.3307 17.7614 18.0922 20 15.3307 20C12.5693 20 10.3307 17.7614 10.3307 15C10.3307 12.2386 12.5693 10 15.3307 10C18.0922 10 20.3307 12.2386 20.3307 15ZM13.6767 12.904C13.5547 12.782 13.3568 12.782 13.2348 12.904C13.1127 13.0261 13.1127 13.2239 13.2348 13.346L14.8888 15L13.2348 16.654C13.1127 16.7761 13.1127 16.9739 13.2348 17.096C13.3568 17.218 13.5547 17.218 13.6767 17.096L15.3307 15.4419L16.9848 17.096C17.1068 17.218 17.3047 17.218 17.4267 17.096C17.5487 16.9739 17.5487 16.7761 17.4267 16.654L15.7727 15L17.4267 13.346C17.5487 13.2239 17.5487 13.0261 17.4267 12.904C17.3047 12.782 17.1068 12.782 16.9848 12.904L15.3307 14.5581L13.6767 12.904Z"
								fill="#94A3B8"
							/>
						</g>
						<defs>
							<clipPath id="clip0_1704:5253">
								<rect
									width="20"
									height="20"
									fill="white"
									transform="translate(0.332031)"
								/>
							</clipPath>
						</defs>
					</svg>
					<div class="text-neutral-500 text-sm ml-2">
						Báo cáo chưa hoàn thành
					</div>
				</div>
				<div class="flex items-center flex-nowrap justify-between">
					<div class="text-neutral-600 font-bold text-4xl">
						{{ stats.incompleted_lesson_report_count }}
					</div>
				</div>
			</div>
		</div>
		<div v-if="data && data.length">
			<div class="shadow-sm sm:rounded-2xl mt-10">
				<div class="__record__table scroll-bar">
					<div class="sm:rounded-t-2xl w-fit min-w-full">
						<table class="min-w-full divide-y text-neutral-200">
							<thead class="bg-neutral-100 h-16">
								<tr>
									<th
										scope="col"
										class="px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
									>
										STT
									</th>
									<th
										scope="col"
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									>
										Ngày
									</th>
									<th
										scope="col"
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									>
										Giờ học
									</th>
									<th
										scope="col"
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									>
										Báo cáo
									</th>
									<th
										scope="col"
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									>
										{{ $filters.terminology('teacher') }}/
										Lớp
									</th>
									<th
										scope="col"
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									>
										Tên học sinh
									</th>
									<th
										scope="col"
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									>
										Trạng thái
									</th>
									<th
										scope="col"
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									>
										Phân loại
									</th>
									<th
										scope="col"
										class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
									>
										Ghi chú
									</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(item, index) in data"
									:key="index"
									:class="
										item.report_state === 'cancelled'
											? 'bg-sienna-50'
											: index % 2 === 0
											? 'bg-white'
											: 'bg-neutral-50'
									"
									class="text-neutral-700"
								>
									<td
										class="px-6 py-4 whitespace-nowrap text-sm text-neutral-700"
									>
										{{ index + 1 }}
									</td>
									<td>
										<div class="px-3 py-4 text-neutral-700">
											<span v-if="item.date">{{
												$filters.formatDate2(item.date)
											}}</span>
										</div>
									</td>
									<td>
										<div class="px-3 py-4 text-neutral-700">
											<span
												v-if="item.display_start_slot"
												>{{
													item.display_start_slot
												}}</span
											>
											<span v-if="item.display_end_slot">
												-
												{{
													item.display_end_slot
												}}</span
											>
										</div>
									</td>
									<td
										class="px-3 py-4 whitespace-nowrap text-neutral-700"
									>
										<svg
											width="21"
											height="20"
											viewBox="0 0 21 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
											v-if="
												item.report_state ===
												'completed'
											"
										>
											<g
												clip-path="url(#clip0_1706:5649)"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M1.5 1.66667C1.5 0.746192 2.2397 0 3.15217 0H16.3696C17.282 0 18.0217 0.746192 18.0217 1.66667V8.81793C17.2564 8.50542 16.4199 8.33333 15.5435 8.33333C11.8936 8.33333 8.93478 11.25 8.93478 14.9319C8.93478 16.9231 9.80012 18.7784 11.1721 20H3.15217C2.2397 20 1.5 19.2538 1.5 18.3333V1.66667ZM2.73913 7.5C2.73913 7.26988 2.92406 7.08333 3.15217 7.08333H11C11.2281 7.08333 11.413 7.26988 11.413 7.5C11.413 7.73012 11.2281 7.91667 11 7.91667H3.15217C2.92406 7.91667 2.73913 7.73012 2.73913 7.5ZM2.73913 10C2.73913 9.76988 2.92406 9.58333 3.15217 9.58333H9.34783C9.57594 9.58333 9.76087 9.76988 9.76087 10C9.76087 10.2301 9.57594 10.4167 9.34783 10.4167H3.15217C2.92406 10.4167 2.73913 10.2301 2.73913 10ZM2.73913 12.5C2.73913 12.2699 2.92406 12.0833 3.15217 12.0833H7.69565C7.92377 12.0833 8.1087 12.2699 8.1087 12.5C8.1087 12.7301 7.92377 12.9167 7.69565 12.9167H3.15217C2.92406 12.9167 2.73913 12.7301 2.73913 12.5ZM2.73913 15C2.73913 14.7699 2.92406 14.5833 3.15217 14.5833H6.04348C6.2716 14.5833 6.45652 14.7699 6.45652 15C6.45652 15.2301 6.2716 15.4167 6.04348 15.4167H3.15217C2.92406 15.4167 2.73913 15.2301 2.73913 15ZM2.73913 3.75C2.73913 3.28976 3.10898 2.91667 3.56522 2.91667H14.7174C15.1736 2.91667 15.5435 3.28976 15.5435 3.75C15.5435 4.21024 15.1736 4.58333 14.7174 4.58333H3.56522C3.10898 4.58333 2.73913 4.21024 2.73913 3.75Z"
													fill="#2AA797"
												/>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M15.5435 20C18.2809 20 20.5 17.7614 20.5 15C20.5 12.2386 18.2809 10 15.5435 10C12.8061 10 10.587 12.2386 10.587 15C10.587 17.7614 12.8061 20 15.5435 20ZM17.3834 13.106C17.5649 12.923 17.8591 12.923 18.0405 13.106C18.2198 13.2869 18.222 13.5786 18.0471 13.7622L15.5737 16.8811C15.5701 16.8856 15.5663 16.8899 15.5623 16.894C15.3808 17.077 15.0866 17.077 14.9051 16.894L13.2655 15.2399C13.084 15.0569 13.084 14.7601 13.2655 14.577C13.4469 14.394 13.7412 14.394 13.9226 14.577L15.2197 15.8855L17.3711 13.1201C17.3749 13.1151 17.379 13.1105 17.3834 13.106Z"
													fill="#2AA797"
												/>
											</g>
											<defs>
												<clipPath id="clip0_1706:5649">
													<rect
														width="20"
														height="20"
														fill="white"
														transform="translate(0.5)"
													/>
												</clipPath>
											</defs>
										</svg>
										<svg
											class="text-orange-500"
											width="20"
											height="20"
											viewBox="0 0 20 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
											v-else-if="
												item.report_state === 'draft'
											"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M2.65217 0C1.7397 0 1 0.746192 1 1.66667V18.3333C1 19.2538 1.7397 20 2.65217 20H10.6721C9.30012 18.7784 8.43478 16.9231 8.43478 14.9319C8.43478 11.25 11.3936 8.33333 15.0435 8.33333C15.9199 8.33333 16.7564 8.50542 17.5217 8.81793V1.66667C17.5217 0.746192 16.782 0 15.8696 0H2.65217ZM2.65217 7.08333C2.42406 7.08333 2.23913 7.26988 2.23913 7.5C2.23913 7.73012 2.42406 7.91667 2.65217 7.91667H10.5C10.7281 7.91667 10.913 7.73012 10.913 7.5C10.913 7.26988 10.7281 7.08333 10.5 7.08333H2.65217ZM2.65217 9.58333C2.42406 9.58333 2.23913 9.76988 2.23913 10C2.23913 10.2301 2.42406 10.4167 2.65217 10.4167H8.84783C9.07594 10.4167 9.26087 10.2301 9.26087 10C9.26087 9.76988 9.07594 9.58333 8.84783 9.58333H2.65217ZM2.65217 12.0833C2.42406 12.0833 2.23913 12.2699 2.23913 12.5C2.23913 12.7301 2.42406 12.9167 2.65217 12.9167H7.19565C7.42377 12.9167 7.6087 12.7301 7.6087 12.5C7.6087 12.2699 7.42377 12.0833 7.19565 12.0833H2.65217ZM2.65217 14.5833C2.42406 14.5833 2.23913 14.7699 2.23913 15C2.23913 15.2301 2.42406 15.4167 2.65217 15.4167H5.54348C5.7716 15.4167 5.95652 15.2301 5.95652 15C5.95652 14.7699 5.7716 14.5833 5.54348 14.5833H2.65217ZM3.06522 2.91667C2.60898 2.91667 2.23913 3.28976 2.23913 3.75C2.23913 4.21024 2.60898 4.58333 3.06522 4.58333H14.2174C14.6736 4.58333 15.0435 4.21024 15.0435 3.75C15.0435 3.28976 14.6736 2.91667 14.2174 2.91667H3.06522Z"
												fill="currentColor"
											/>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M15.0435 20C17.7809 20 20 17.7614 20 15C20 12.2386 17.7809 10 15.0435 10C12.3061 10 10.087 12.2386 10.087 15C10.087 17.7614 12.3061 20 15.0435 20ZM15.0435 11.3542C14.4491 11.3542 13.864 11.502 13.3398 11.7847C12.8156 12.0673 12.3686 12.476 12.0384 12.9745C11.7082 13.473 11.505 14.046 11.4468 14.6426C11.3885 15.2393 11.477 15.8413 11.7045 16.3952C11.9319 16.9491 12.2913 17.4379 12.7507 17.8183C13.2101 18.1986 13.7555 18.4588 14.3384 18.5758C14.9213 18.6927 15.5239 18.6629 16.0926 18.4888C16.6614 18.3148 17.1788 18.0019 17.5991 17.578C17.6619 17.5146 17.7223 17.449 17.7801 17.3814L18.1711 17.7216C18.105 17.7988 18.036 17.8738 17.9641 17.9463C17.4838 18.4308 16.8925 18.7883 16.2425 18.9873C15.5925 19.1862 14.9039 19.2203 14.2377 19.0866C13.5715 18.9529 12.9482 18.6556 12.4232 18.2209C11.8981 17.7862 11.4874 17.2276 11.2275 16.5945C10.9675 15.9615 10.8664 15.2735 10.9329 14.5916C10.9995 13.9097 11.2318 13.2549 11.6091 12.6851C11.9865 12.1154 12.4974 11.6483 13.0964 11.3253C13.6955 11.0023 14.3642 10.8333 15.0435 10.8333C15.1451 10.8333 15.2465 10.8371 15.3473 10.8446L15.3094 11.364C15.2211 11.3575 15.1324 11.3542 15.0435 11.3542ZM16.3442 11.5985C16.1786 11.534 16.0085 11.482 15.8353 11.4428L15.9485 10.9346C16.1464 10.9794 16.3408 11.0389 16.53 11.1125L16.3442 11.5985ZM17.0514 11.9686C16.9774 11.9188 16.9019 11.8718 16.8249 11.8278L17.0794 11.3746C17.1674 11.4249 17.2537 11.4786 17.3382 11.5355C17.4227 11.5925 17.5049 11.6524 17.5847 11.7152L17.267 12.1258C17.1972 12.0709 17.1253 12.0184 17.0514 11.9686ZM17.9983 12.9007C17.8961 12.7543 17.7834 12.6157 17.661 12.486L18.0349 12.1269C18.1748 12.2751 18.3037 12.4335 18.4205 12.6008L17.9983 12.9007ZM18.3825 13.6048C18.3485 13.5219 18.3115 13.4405 18.2717 13.3608L18.7329 13.1266C18.7784 13.2178 18.8206 13.3108 18.8595 13.4055C18.8984 13.5002 18.9337 13.5961 18.9654 13.693L18.4752 13.8564C18.4474 13.7716 18.4165 13.6877 18.3825 13.6048ZM18.6565 14.9105C18.6522 14.7315 18.6347 14.5531 18.6044 14.3767L19.1131 14.2877C19.1478 14.4893 19.1677 14.6932 19.1727 14.8977L18.6565 14.9105ZM18.5882 15.7113C18.6055 15.6233 18.6196 15.5349 18.6304 15.4463L19.1429 15.51C19.1305 15.6113 19.1144 15.7123 19.0945 15.8129C19.0747 15.9134 19.0513 16.013 19.0243 16.1113L18.5267 15.9724C18.5503 15.8863 18.5708 15.7993 18.5882 15.7113ZM18.0969 16.9505C18.1918 16.7992 18.2756 16.6411 18.3476 16.4774L18.8196 16.6885C18.7374 16.8756 18.6416 17.0563 18.5331 17.2292L18.0969 16.9505ZM15.0435 12.6562C15.0435 12.5124 14.9279 12.3958 14.7853 12.3958C14.6428 12.3958 14.5272 12.5124 14.5272 12.6562V15.5208C14.5272 15.6143 14.5768 15.7006 14.6572 15.7469L16.4643 16.7886C16.5881 16.86 16.7458 16.8166 16.8165 16.6917C16.8873 16.5668 16.8443 16.4078 16.7205 16.3364L15.0435 15.3697V12.6562Z"
												fill="currentColor"
											/>
										</svg>
										<svg
											width="21"
											height="20"
											viewBox="0 0 21 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
											v-else-if="
												item.report_state ===
													'cancelled' ||
												item.report_state === 'deleted'
											"
										>
											<g
												clip-path="url(#clip0_1739:6086)"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M2.9987 0C2.07822 0 1.33203 0.746192 1.33203 1.66667V18.3333C1.33203 19.2538 2.07822 20 2.9987 20H11.089C9.70496 18.7784 8.83203 16.9231 8.83203 14.9319C8.83203 11.25 11.8168 8.33333 15.4987 8.33333C16.3828 8.33333 17.2267 8.50542 17.9987 8.81793V1.66667C17.9987 0.746192 17.2525 0 16.332 0H2.9987ZM2.9987 7.08333C2.76858 7.08333 2.58203 7.26988 2.58203 7.5C2.58203 7.73012 2.76858 7.91667 2.9987 7.91667H10.9154C11.1455 7.91667 11.332 7.73012 11.332 7.5C11.332 7.26988 11.1455 7.08333 10.9154 7.08333H2.9987ZM2.9987 9.58333C2.76858 9.58333 2.58203 9.76988 2.58203 10C2.58203 10.2301 2.76858 10.4167 2.9987 10.4167H9.2487C9.47882 10.4167 9.66536 10.2301 9.66536 10C9.66536 9.76988 9.47882 9.58333 9.2487 9.58333H2.9987ZM2.9987 12.0833C2.76858 12.0833 2.58203 12.2699 2.58203 12.5C2.58203 12.7301 2.76858 12.9167 2.9987 12.9167H7.58203C7.81215 12.9167 7.9987 12.7301 7.9987 12.5C7.9987 12.2699 7.81215 12.0833 7.58203 12.0833H2.9987ZM2.9987 14.5833C2.76858 14.5833 2.58203 14.7699 2.58203 15C2.58203 15.2301 2.76858 15.4167 2.9987 15.4167H5.91536C6.14548 15.4167 6.33203 15.2301 6.33203 15C6.33203 14.7699 6.14548 14.5833 5.91536 14.5833H2.9987ZM3.41536 2.91667C2.95513 2.91667 2.58203 3.28976 2.58203 3.75C2.58203 4.21024 2.95513 4.58333 3.41536 4.58333H14.6654C15.1256 4.58333 15.4987 4.21024 15.4987 3.75C15.4987 3.28976 15.1256 2.91667 14.6654 2.91667H3.41536Z"
													fill="#E37056"
												/>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M20.4987 15C20.4987 17.7614 18.2601 20 15.4987 20C12.7373 20 10.4987 17.7614 10.4987 15C10.4987 12.2386 12.7373 10 15.4987 10C18.2601 10 20.4987 12.2386 20.4987 15ZM13.8447 12.904C13.7226 12.782 13.5248 12.782 13.4027 12.904C13.2807 13.0261 13.2807 13.2239 13.4027 13.346L15.0568 15L13.4027 16.654C13.2807 16.7761 13.2807 16.9739 13.4027 17.096C13.5248 17.218 13.7226 17.218 13.8447 17.096L15.4987 15.4419L17.1527 17.096C17.2748 17.218 17.4726 17.218 17.5947 17.096C17.7167 16.9739 17.7167 16.7761 17.5947 16.654L15.9406 15L17.5947 13.346C17.7167 13.2239 17.7167 13.0261 17.5947 12.904C17.4726 12.782 17.2748 12.782 17.1527 12.904L15.4987 14.5581L13.8447 12.904Z"
													fill="#E37056"
												/>
											</g>
											<defs>
												<clipPath id="clip0_1739:6086">
													<rect
														width="20"
														height="20"
														fill="white"
														transform="translate(0.5)"
													/>
												</clipPath>
											</defs>
										</svg>
										<svg
											width="21"
											height="20"
											viewBox="0 0 21 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
											v-else
										>
											<g
												clip-path="url(#clip0_1739:6086)"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M2.9987 0C2.07822 0 1.33203 0.746192 1.33203 1.66667V18.3333C1.33203 19.2538 2.07822 20 2.9987 20H11.089C9.70496 18.7784 8.83203 16.9231 8.83203 14.9319C8.83203 11.25 11.8168 8.33333 15.4987 8.33333C16.3828 8.33333 17.2267 8.50542 17.9987 8.81793V1.66667C17.9987 0.746192 17.2525 0 16.332 0H2.9987ZM2.9987 7.08333C2.76858 7.08333 2.58203 7.26988 2.58203 7.5C2.58203 7.73012 2.76858 7.91667 2.9987 7.91667H10.9154C11.1455 7.91667 11.332 7.73012 11.332 7.5C11.332 7.26988 11.1455 7.08333 10.9154 7.08333H2.9987ZM2.9987 9.58333C2.76858 9.58333 2.58203 9.76988 2.58203 10C2.58203 10.2301 2.76858 10.4167 2.9987 10.4167H9.2487C9.47882 10.4167 9.66536 10.2301 9.66536 10C9.66536 9.76988 9.47882 9.58333 9.2487 9.58333H2.9987ZM2.9987 12.0833C2.76858 12.0833 2.58203 12.2699 2.58203 12.5C2.58203 12.7301 2.76858 12.9167 2.9987 12.9167H7.58203C7.81215 12.9167 7.9987 12.7301 7.9987 12.5C7.9987 12.2699 7.81215 12.0833 7.58203 12.0833H2.9987ZM2.9987 14.5833C2.76858 14.5833 2.58203 14.7699 2.58203 15C2.58203 15.2301 2.76858 15.4167 2.9987 15.4167H5.91536C6.14548 15.4167 6.33203 15.2301 6.33203 15C6.33203 14.7699 6.14548 14.5833 5.91536 14.5833H2.9987ZM3.41536 2.91667C2.95513 2.91667 2.58203 3.28976 2.58203 3.75C2.58203 4.21024 2.95513 4.58333 3.41536 4.58333H14.6654C15.1256 4.58333 15.4987 4.21024 15.4987 3.75C15.4987 3.28976 15.1256 2.91667 14.6654 2.91667H3.41536Z"
													fill="#94A3B8"
												/>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M20.4987 15C20.4987 17.7614 18.2601 20 15.4987 20C12.7373 20 10.4987 17.7614 10.4987 15C10.4987 12.2386 12.7373 10 15.4987 10C18.2601 10 20.4987 12.2386 20.4987 15ZM13.8447 12.904C13.7226 12.782 13.5248 12.782 13.4027 12.904C13.2807 13.0261 13.2807 13.2239 13.4027 13.346L15.0568 15L13.4027 16.654C13.2807 16.7761 13.2807 16.9739 13.4027 17.096C13.5248 17.218 13.7226 17.218 13.8447 17.096L15.4987 15.4419L17.1527 17.096C17.2748 17.218 17.4726 17.218 17.5947 17.096C17.7167 16.9739 17.7167 16.7761 17.5947 16.654L15.9406 15L17.5947 13.346C17.7167 13.2239 17.7167 13.0261 17.5947 12.904C17.4726 12.782 17.2748 12.782 17.1527 12.904L15.4987 14.5581L13.8447 12.904Z"
													fill="#94A3B8"
												/>
											</g>
											<defs>
												<clipPath id="clip0_1739:6086">
													<rect
														width="20"
														height="20"
														fill="white"
														transform="translate(0.5)"
													/>
												</clipPath>
											</defs>
										</svg>
									</td>
									<td
										class="px-3 py-4 whitespace-nowrap text-neutral-700"
									>
										<div
											v-if="item.staff_ids"
											class="flex flex-col gap-2"
										>
											<div
												@click.stop="
													$router.push(
														`/record/employee/${staff_id}`
													)
												"
												class="flex items-center"
												v-for="staff_id in item.staff_ids"
												:key="staff_id"
											>
												<div v-if="getStaff(staff_id)">
													<img
														class="shadow-sm inline-block h-9 w-9 rounded-full"
														:src="
															getStaff(staff_id)
																?.profile_photo
																?.w200
														"
														alt=""
														v-if="
															getStaff(staff_id)
																?.profile_photo
																?.w200
														"
													/>
													<span
														v-else
														class="inline-flex items-center justify-center h-9 w-9 rounded-full"
														:style="{
															background:
																getStaff(
																	staff_id
																)?.profile_photo
																	?.default
																	?.color,
														}"
													>
														<span
															class="font-medium leading-none text-white text-xs"
															>{{
																getStaff(
																	staff_id
																)?.profile_photo
																	?.default
																	?.initial
															}}</span
														>
													</span>
												</div>
												<div
													v-if="getStaff(staff_id)"
													class="ml-4 text-blue-600 hover:text-blue-700 hover:underline cursor-pointer font-semibold whitespace-pre-wrap w-40"
												>
													{{
														getStaff(staff_id).name
													}}
												</div>
											</div>
										</div>
									</td>
									<td
										class="px-3 py-4 whitespace-nowrap text-neutral-700"
									>
										<div
											@click.stop="
												$router.push(
													`/record/student/${item.student_id}`
												)
											"
											class="flex items-center"
											v-if="student"
										>
											<div>
												<img
													class="shadow-sm inline-block h-9 w-9 rounded-full"
													:src="
														student?.profile_photo
															?.w200
													"
													alt=""
													v-if="
														student?.profile_photo
															?.w200
													"
												/>
												<span
													v-else
													class="inline-flex items-center justify-center h-9 w-9 rounded-full"
													:style="{
														background:
															student
																?.profile_photo
																?.default
																?.color,
													}"
												>
													<span
														class="font-medium leading-none text-white text-xs"
														>{{
															student
																?.profile_photo
																?.default
																?.initial
														}}</span
													>
												</span>
											</div>
											<div
												class="ml-4 text-yellow-600 font-semibold hover:text-yellow-700 hover:underline cursor-pointer whitespace-pre-wrap w-40"
											>
												{{ student.name }}
											</div>
										</div>
									</td>
									<td
										class="px-3 py-4 whitespace-nowrap text-neutral-700"
									>
										<div>
											<div
												v-if="item.state === 'ongoing'"
												class="text-xs w-fit font-semibold bg-blue-100 text-blue-600 p-2 px-4 pb-1.5 rounded-full flex items-center justify-center gap-2"
											>
												<div>
													<svg
														width="15"
														height="14"
														viewBox="0 0 15 14"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M7.5 14C11.366 14 14.5 10.866 14.5 7C14.5 3.13401 11.366 0 7.5 0C3.63401 0 0.5 3.13401 0.5 7C0.5 10.866 3.63401 14 7.5 14ZM11.0491 6.63407C10.9689 6.50148 10.846 6.41667 10.7083 6.41667H4.58333C4.44564 6.41667 4.3228 6.50148 4.2426 6.63407C4.14461 6.72535 4.08333 6.85552 4.08333 7C4.08333 7.14448 4.14461 7.27465 4.2426 7.36593C4.3228 7.49852 4.44564 7.58333 4.58333 7.58333H10.7083C10.846 7.58333 10.9689 7.49852 11.0491 7.36593C11.1471 7.27465 11.2083 7.14448 11.2083 7C11.2083 6.85552 11.1471 6.72535 11.0491 6.63407Z"
															fill="#CBD5E1"
														/>
													</svg>
												</div>
												<div>Đang học</div>
											</div>
											<div
												v-if="
													item.state !== 'created' &&
													item.state !==
														'cancelled' &&
													item.state !== 'ongoing'
												"
												class="text-xs w-fit font-semibold bg-neutral-100 text-gray-500 p-2 px-4 pb-1.5 rounded-full flex items-center justify-center gap-2"
											>
												<div>
													<svg
														width="15"
														height="14"
														viewBox="0 0 15 14"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M7.5 14C11.366 14 14.5 10.866 14.5 7C14.5 3.13401 11.366 0 7.5 0C3.63401 0 0.5 3.13401 0.5 7C0.5 10.866 3.63401 14 7.5 14ZM11.0491 6.63407C10.9689 6.50148 10.846 6.41667 10.7083 6.41667H4.58333C4.44564 6.41667 4.3228 6.50148 4.2426 6.63407C4.14461 6.72535 4.08333 6.85552 4.08333 7C4.08333 7.14448 4.14461 7.27465 4.2426 7.36593C4.3228 7.49852 4.44564 7.58333 4.58333 7.58333H10.7083C10.846 7.58333 10.9689 7.49852 11.0491 7.36593C11.1471 7.27465 11.2083 7.14448 11.2083 7C11.2083 6.85552 11.1471 6.72535 11.0491 6.63407Z"
															fill="#CBD5E1"
														/>
													</svg>
												</div>
												<div>Chưa học</div>
											</div>
											<div
												v-if="
													item.state === 'cancelled'
												"
												class="text-sm w-fit font-semibold bg-sienna-100 text-sienna-500 p-2 px-4 pb-1.5 rounded-full flex items-center justify-center gap-2"
											>
												<div>
													<svg
														width="15"
														height="14"
														viewBox="0 0 15 14"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M5.19063 4.35739C5.36148 4.18653 5.63849 4.18653 5.80934 4.35739L8.12498 6.67303L10.4406 4.35739C10.6115 4.18653 10.8885 4.18653 11.0593 4.35739C11.2302 4.52824 11.2302 4.80525 11.0593 4.97611L8.7437 7.29175L11.0593 9.60739C11.2302 9.77824 11.2302 10.0553 11.0593 10.2261C10.8885 10.397 10.6115 10.397 10.4406 10.2261L8.12498 7.91047L5.80934 10.2261C5.63849 10.397 5.36148 10.397 5.19063 10.2261C5.01977 10.0553 5.01977 9.77824 5.19063 9.60739L7.50627 7.29175L5.19063 4.97611C5.01977 4.80525 5.01977 4.52824 5.19063 4.35739Z"
															fill="#DB5A41"
														/>
													</svg>
												</div>
												<div>
													{{
														item.student_on_leave
															? 'HS Nghỉ'
															: `${$filters.terminology(
																	'teacher_short_name'
															  )} Nghỉ`
													}}
												</div>
											</div>
											<div
												v-if="item.state === 'created'"
												class="text-xs w-fit font-semibold bg-green-50 text-green-500 p-2 px-4 pb-1.5 rounded-full flex items-center justify-center gap-2"
											>
												<div>
													<svg
														width="15"
														height="14"
														viewBox="0 0 15 14"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M8.68176 4.34846C8.93804 4.09218 9.35355 4.09218 9.60983 4.34846C9.86297 4.6016 9.86608 5.01009 9.61915 5.26704L6.12597 9.63351C6.12093 9.63981 6.11554 9.64583 6.10983 9.65154C5.85355 9.90782 5.43804 9.90782 5.18176 9.65154L2.86612 7.3359C2.60983 7.07962 2.60983 6.6641 2.86612 6.40782C3.1224 6.15154 3.53791 6.15154 3.79419 6.40782L5.62602 8.23965L8.66435 4.36809C8.66975 4.36121 8.67557 4.35465 8.68176 4.34846Z"
															fill="#339588"
														/>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M7.87639 8.84617L8.68176 9.65154C8.93804 9.90782 9.35355 9.90782 9.60984 9.65154C9.61554 9.64583 9.62093 9.63981 9.62597 9.63351L13.1191 5.26704C13.3661 5.01009 13.363 4.6016 13.1098 4.34846C12.8536 4.09218 12.438 4.09218 12.1818 4.34846C12.1756 4.35465 12.1698 4.36121 12.1644 4.36809L9.12602 8.23965L8.70135 7.81497L7.87639 8.84617Z"
															fill="#339588"
														/>
													</svg>
												</div>
												<div>Đã học</div>
											</div>
										</div>
									</td>
									<td
										class="px-3 py-4 whitespace-nowrap text-neutral-700"
									>
										<div>
											<div
												v-if="!item.scheduled"
												class="text-xs w-fit font-semibold text-sienna-600 p-2 px-4 pb-1.5 rounded-full border border-sienna-200 flex items-center justify-center"
											>
												Phát sinh
											</div>
											<div
												v-else
												class="text-xs w-fit font-semibold text-neutral-600 p-2 px-4 pb-1.5 rounded-full border border-neutral-300 flex items-center justify-center"
											>
												Cố định
											</div>
										</div>
									</td>
									<td
										class="px-3 py-4 whitespace-nowrap text-neutral-700"
									>
										<div
											class="text-neutral-600"
											style="
												max-width: 200px;
												white-space: break-spaces;
											"
										>
											<div v-if="item.unscheduled_note">
												<span class="font-semibold"
													>Phát sinh: </span
												>{{ item.unscheduled_note }}
											</div>
											<div v-if="item.leave_note">
												<span class="font-semibold"
													>Báo nghỉ: </span
												>{{ item.leave_note }}
											</div>
											<div v-if="item.staff_change_note">
												<span class="font-semibold"
													>Đổi
													{{
														$filters.terminology(
															'teacher_short_name'
														)
													}}: </span
												>{{ item.staff_change_note }}
											</div>
											<div v-if="item.slot_change_note">
												<span class="font-semibold"
													>Đổi giờ:
												</span>
												{{ item.slot_change_note }}
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div
			v-else
			class="w-full h-full flex items-center justify-center flex-col mt-10"
		>
			<img
				src="@/assets/images/illustrations/not_found.png"
				alt=""
				height="250"
				width="250"
			/>
			<div
				class="text-neutral-500 text-lg text-center"
				style="max-width: 700px"
			>
				Không có lịch học cá nhân hôm nay
			</div>
		</div>
	</div>
</template>

<script>
import { $api } from '@/services';
import { flattenMap } from '@/helper/flattenMap';

export default {
	name: 'ScheduleStatsDetailClass',

	props: {
		timeData: {
			type: Object,
			required: true,
		},
		student: {
			type: Object,
			required: true,
		},
	},

	data() {
		return {
			staffs_map: {},
			stats: {
				completed_lesson_report_count: 0,
				incompleted_lesson_report_count: 0,
				staffs_count: 0,
				total_cancelled_hours: '0',
				total_hours: '0',
				total_non_cancelled_hours: '0',
				total_unscheduled_hours: '0',
				incompleted_hours: 0,
			},
			data: [],
		};
	},
	computed: {
		studentId() {
			return this.$route.query.student_id;
		},
	},

	created() {
		this.getScheduleStatsStudent();
	},

	methods: {
		getStaff(staff_id) {
			return this.staffs_map[staff_id];
		},

		async getScheduleStatsStudent() {
			try {
				const {
					data: { data, stats, staffs_map },
				} = await $api.schedule.scheduleStatsStudentByMonth({
					...this.timeData,
					student_id: this.studentId,
				});
				this.stats = stats;
				this.data = data;
				this.staffs_map = flattenMap(staffs_map);
			} catch (e) {
				console.log(e);
			}
		},
	},
};
</script>
